module.exports = __webpack_public_path__ + "static/media/400009_02.39f57230.png";